import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { RouterModule } from '@angular/router';
import { CardCategoryComponent } from './card-category.component';

@NgModule({
  declarations: [
    CardCategoryComponent
  ],
  imports: [
    CommonModule,
    NgxSkeletonLoaderModule,
    RouterModule
  ],
  exports: [
    CardCategoryComponent
  ],
})
export class CardCategoryModule { }
